import { toExportQueryPayload } from '../genericResourceAdapter'
import { typeSelectionLabel } from '../resourceTypeFilter'
import { toAiAssistantExportQueryPayload } from '../../aiAssistantManage/aiAssistantAdapter'
import { AI_ASSISTANT_LIST_RESOURCE_TYPE } from '../../aiAssistantManage/aiAssistantConstants'

/**
 * 判断列表是否存在有效筛选条件，用于 Excel 打标在无勾选时确定作用范围。
 */
export function hasActiveFilters(filters) {
  const hasStatus =
    filters.wallpaperStatus !== '' &&
    filters.wallpaperStatus !== null &&
    filters.wallpaperStatus !== undefined
  return !!(
    filters.resourceName ||
    filters.roleName ||
    filters.assetType ||
    hasStatus ||
    filters.categoryType ||
    filters.key ||
    filters.dataSetId
  )
}

/**
 * 构建筛选摘要文案，供「是否对 xxx 打标」确认框展示。
 */
export function buildFilterSummary(filters, { categoryOptions = [], dataOptions = [], statusOptions = [] } = {}) {
  const parts = []
  if (filters.resourceName) {
    parts.push(`资源名称=${filters.resourceName}`)
  }
  if (filters.roleName) {
    parts.push(`角色名称=${filters.roleName}`)
  }
  if (filters.assetType) {
    parts.push(`资源类型=${typeSelectionLabel(filters.assetType)}`)
  }
  if (filters.wallpaperStatus !== '' && filters.wallpaperStatus !== null && filters.wallpaperStatus !== undefined) {
    const statusItem = statusOptions.find((item) => String(item.value) === String(filters.wallpaperStatus))
    parts.push(`状态=${statusItem ? statusItem.label : filters.wallpaperStatus}`)
  }
  if (filters.key) {
    parts.push(`资源 Key=${filters.key}`)
  }
  if (filters.categoryType) {
    const category = categoryOptions.find((item) => item.id === filters.categoryType)
    parts.push(`资源分类=${category ? category.name : filters.categoryType}`)
  }
  if (filters.dataSetId) {
    const dataSet = dataOptions.find((item) => item.id === filters.dataSetId)
    parts.push(`数据集=${dataSet ? dataSet.name : filters.dataSetId}`)
  }
  return parts.length ? parts.join('；') : '无'
}

/** 导出/打标模板 payload：通用资源走 generic adapter；Ai 角色走 name2 + resourceType=15。 */
export function buildExportPayload(resourceType, filters, keySet) {
  if (Number(resourceType) === AI_ASSISTANT_LIST_RESOURCE_TYPE) {
    return toAiAssistantExportQueryPayload(resourceType, filters, keySet)
  }
  return toExportQueryPayload(resourceType, filters, keySet)
}

export function buildScopeLabel(selection, filters, meta) {
  if (selection && selection.length) {
    return `已选 ${selection.length} 项`
  }
  if (hasActiveFilters(filters)) {
    return `当前筛选：${buildFilterSummary(filters, meta)}`
  }
  return '未确定范围'
}

/**
 * 弹窗顶栏 scope 文案：共用资源区 + 当前 Tab 语义。
 */
export function buildDialogScopeLabel({
  selectionCount = 0,
  hasFilters = false,
  filterScopeConfirmed = false,
  filterSummary = '',
  activeTab = 'page',
} = {}) {
  if (selectionCount > 0) {
    return `已选 ${selectionCount} 项 · ${activeTab === 'page' ? '选择 Tag' : 'Excel 打标'}`
  }
  if (hasFilters && filterScopeConfirmed) {
    return `筛选范围已确认 · ${filterSummary}`
  }
  if (hasFilters) {
    return `当前筛选 · ${filterSummary}`
  }
  return '请选择要打标的资源'
}

/** @deprecated 页面打标内嵌 pick 步已移除，保留兼容旧引用 */
export function buildPageScopeLabel(step, selectionCount) {
  if (selectionCount > 0) {
    return `已选 ${selectionCount} 项`
  }
  return '请选择要打标的资源'
}
